import * as React from 'react';

import './CreditsFilterBar.scss';
import Select from 'src/components/common/Select';

interface ICreditsFilterBarProps {
  statusFilter: 'PENDING' | 'VOID' | 'DISPOSED';
  getCredits: (
    page: number,
    status: 'PENDING' | 'VOID' | 'DISPOSED',
    sortby: string
  ) => void;
  sortby: string;
}

class CreditsFilterBar extends React.Component<ICreditsFilterBarProps, any> {
  private setStatusFilter = (option: {
    value: 'PENDING' | 'VOID' | 'DISPOSED' | null;
    label: string;
  }) => {
    this.props.getCredits(0, option.value, this.props.sortby);
  };

  private getActiveOption = (status: any[]) => {
    const filter = status.find(
      element => element.value === this.props.statusFilter
    );
    return filter ? filter : null;
  };

  public render() {
    const status = [
      { value: 'PENDING', label: 'Pending' },
      { value: 'VOID', label: 'Void' },
      { value: 'DISPOSED', label: 'Disposed' },
      { value: null, label: 'All Credit Payments' }
    ];

    return (
      <div className="rp-credits-filterbar row">
        <div className="col-12 col-md-9 rp-credits-filterbar-title">
          <h4>Apply Credits Payments:</h4>
        </div>
        <div className="col-12 col-md-3 rp-credits-filterbar-box d-flex flex-column flex-lg-row align-items-end justify-content-between">
          <div className="rp-credits-filterbar-transaction-type-filter">
            <h5 className="rp-credits-filterbar-top">Filter by:</h5>
            <Select
              options={status}
              optionsShown={4}
              activeOption={this.getActiveOption(status)}
              onSelected={option => {
                this.setStatusFilter(option);
              }}
              width={'100%'}
              height={'40px'}
              isLoading={false}
              placeholder={'Status'}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CreditsFilterBar;
